import { BodyCreateWithAssign, BodyUpdateWithAssign } from "src/entity/map-company-user/map-company-user";
import http from "../utils/http-common";
import { CreateMappingCompanyDto, UpdateMappingCompanyDto } from "src/entity/company/company-response.entity";
import { FilterSearchCompanyMap } from "src/entity/company/company-mapping.entity";
import { UpsertFocusCompany } from "src/entity/company/focus-company.entity";

const baseCompanyPath = "/api/company";

export const upsertFocusCompany = (data: UpsertFocusCompany) => {
  return http.post(`${baseCompanyPath}/focus/menu`, data);
};

export const getFocusCompany = (companyId: string) => {
  return http.get(`${baseCompanyPath}/focus/menu/${companyId}`);
};

export const getAllRegion = () => {
  return http.get(`${baseCompanyPath}/region`);
};

export const getAllOrganization = () => {
  return http.get(`${baseCompanyPath}/organization`);
};

export const getAllCompanyGroup = () => {
  return http.get(`${baseCompanyPath}/company-group`);
};

export const getAllArea = () => {
  return http.get(`${baseCompanyPath}/area`);
};
export const getAreaByCompanyId = (companyId: string) => {
  return http.get(`${baseCompanyPath}/area/${companyId}`);
};
export const getCompanyAreaDetail = () => {
  return http.get(`${baseCompanyPath}/company/areas/details`);
};
export const getFilterAdminUsrManagement = () => {
  return http.get(`${baseCompanyPath}/filter/admin`);
};
export const getUnAssignRoleInCompany = () => {
  return http.get(`${baseCompanyPath}/un-assign/role`);
};

export const createMappingCompany = (data: CreateMappingCompanyDto) => {
  return http.post(`${baseCompanyPath}/mapping-company`, data);
};

export const updateMappingCompany = (data: UpdateMappingCompanyDto) => {
  return http.put(`${baseCompanyPath}/update/mapping-company`, data);
};
export const deleteMappingCompany = (mappingId: string) => {
  return http.delete(`${baseCompanyPath}/mapping-company/${mappingId}`);
};
export const searchMappingCompany = (data: FilterSearchCompanyMap) => {
  return http.post(`${baseCompanyPath}/get/mapping-company`, data);
};

export const CompanyService = {
  getAllRegion,
  getAllOrganization,
  getAllCompanyGroup,
  getAllArea,
  createMappingCompany,
  searchMappingCompany,
  updateMappingCompany,
  deleteMappingCompany,
  getUnAssignRoleInCompany,
  upsertFocusCompany,
  getFocusCompany,
};
